import { Helmet } from 'react-helmet-async'

const BASE_URL = 'https://kartquiz.fr'

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'KartQuiz',
  url: BASE_URL,
  logo: `${BASE_URL}/images/logo-kartquiz.png`,
  founder: { '@type': 'Organization', name: 'BCOMING.Digital' },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Lyon',
    postalCode: '69005',
    addressCountry: 'FR',
  },
}

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'KartQuiz',
  url: BASE_URL,
}

export default function SEOHead({
  title,
  description = 'Transforme tes quiz en course de kart. Bonus, attaques, IA, synthèse pédagogique. Bêta gratuite, sans inscription côté élève.',
  canonical,
  ogImage = '/images/og-default.svg',
  robots = 'index, follow',
  jsonLd,
}) {
  const fullTitle = title
    ? `${title} | KartQuiz`
    : 'KartQuiz : tes élèves vont se battre. Pour réviser. | Quiz interactif gratuit'

  const jsonLdArray = [orgJsonLd, websiteJsonLd, ...(jsonLd ? [jsonLd] : [])]

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      {canonical && <link rel="canonical" href={`${BASE_URL}${canonical}`} />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${BASE_URL}${ogImage}`} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical ? `${BASE_URL}${canonical}` : BASE_URL} />
      <meta property="og:locale" content="fr_FR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${BASE_URL}${ogImage}`} />

      {jsonLdArray.map((item, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(item)}</script>
      ))}
    </Helmet>
  )
}
